
export enum LoadingSise {
  XSmall = 'xsmall',
  Small = 'small',
  Normal = 'normal',
  Medium = 'medium',
  Large = 'large',
  XLarge = 'xlarge'
}

export enum TrendsExportTypeEnum {
  Excel = 'excel',
  CSV = 'csv',
}

export const DateFormat = 'M d';

export interface BudgetRangeKey {
  from?: number;
  to?: number;
}

export interface BudgetRange {
  key: BudgetRangeKey;
  count: number;
}

export interface PropertyType {
  key: string;
  count: number;
}

export interface Counters {
  propertyTypes: PropertyType[];
}

export const PriceLowToHigh = 'Price - Low to High';
export const PriceHighToLow = 'Price - High to Low';